import { readingConstants } from '../actions/constants/readingConstants';

const initialReading = {
	items: [],	
	error: '',
	isFilterAndTotalCountDataLoaded: false,
	isDetailComplete: false,
	isDeleteComplete: false
};

const readingData = (state = initialReading, action: any) => {
	switch (action.type) {
		case readingConstants.ReadingGetByFilterRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case readingConstants.ReadingGetByFilterSuccess:			
			if (!state.isFilterAndTotalCountDataLoaded) {
				return {
					...state,
					isLoading: false,
					isError: false,
					isListSuccess: true,
					isSuccess: true,
					isFilterAndTotalCountDataLoaded: true,
					status: action.payload.status,
					items: (action.payload !== "" && action.payload !== null) ? action.payload.readings:[],					
					totalCount: (action.payload !== "" && action.payload !== null) ? action.payload.totalCount : 1	
				};
			}
			else {
				return {
					...state,
					isLoading: false,
					isError: false,
					isListSuccess: true,
					isSuccess: true,
					status: action.payload.status,
					items: (action.payload !== "" && action.payload !== null) ? action.payload.readings : [],
					totalCount: (action.payload !== "" && action.payload !== null) ? action.payload.totalCount : 1					
				};
			}
		case readingConstants.ReadingGetByFilterFailure:
			return {
				...state,
				isLoading: false,				
				isError: true,
				isListSuccess: true,
				status: action.payload,
				items: []
			};

		case readingConstants.ReadingGetDetailRequest:
			return {
				...state,
				isLoading: true,
				isDetailComplete: false,
				isError: false,
				isSuccess: false,
			};
		case readingConstants.ReadingGetDetailSuccess:
			return {
				...state,
				isLoading: false,				
				isError: false,
				isDetailComplete: true,
				isSuccess: true,
				readingsInput: action.payload.reading
			};
		case readingConstants.ReadingGetDetailFailure:
			return {
				...state,
				isLoading: false,				
				isError: true,
				isSucess:false,
				isDetailComplete: false,
				status: action.payload
			};

		case readingConstants.ReadingSaveRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false
			};
		case readingConstants.ReadingSaveSuccess:
			return {
				...state,
				isLoading: false,				
				isError: false,
				isSuccess: true,
				reading: action.payload.reading,
				status: action.payload.status
			};
		case readingConstants.ReadingSaveFailure:
			return {
				...state,
				isLoading: false,				
				isError: true,
				isSuccess: false,
				status: action.payload
			};

		case readingConstants.ReadingTitleGetRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isTitleListSuccess: false
			}
		case readingConstants.ReadingTitleGetSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isTitleListSuccess:true,
				items:action.payload.readings
			}
		case readingConstants.ReadingTitleGetFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isTitleListSuccess: false
			}

		case readingConstants.ReadingTextUpdateRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			}
		case readingConstants.ReadingTextUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateText:true,
				status: action.payload.status
			}
		case readingConstants.ReadingTextUpdateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isUpdateText: true,
				isError: true,
				status:action.payload
			}

		case readingConstants.ReadingDeleteRequest:
			return {
				...state,
				isLoading: true,
				isError:false,
				isDeleteCompleted: false,
				isSuccess: false
			};
		case readingConstants.ReadingDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isDeleteCompleted: true,
				status: action.payload.status
			};
		case readingConstants.ReadingDeleteFailure:
			return {
				...state,
				isLoading: false,				
				isSuccess: false,
				isError:true,
				isDeleteCompleted: true,
				status: action.payload
			};

		default:
			return state;
	}
};

export default readingData;